module.exports = " <div class=asset-folder-fieldtype-wrapper> <small class=help-block v-if=!container>{{ translate('cp.select_asset_container') }}</small> <div v-if=\"container && loading\" class=\"loading loading-basic\"> <span class=\"icon icon-circular-graph animation-spin\"></span> {{ translate('cp.loading') }} </div> <select-fieldtype v-if=\"container && !loading\" :name=name :data.sync=data :config=selectConfig></select-fieldtype> </div> ";


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-html-loader!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./app/statamic/resources/js/components/fieldtypes/AssetsFolderFieldtype.vue
// module id = 570
// module chunks = 0